(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('UserSignatureService', UserSignatureService);

  UserSignatureService.$inject = ['$resource'];

	 function UserSignatureService ($resource) {
    return $resource(apiUrl + '/user-signature/:id', { id: '@id' }, {
      create: { method: 'POST', params: {}, isArray: false },
      update: { method: 'POST', params: { _method: 'PATCH' }, isArray: false },
      select: { method: 'GET', params: { _method: 'GET' }, isArray: false }
    });
  }
})();
